var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.36994 7.49023L9.68994 18.8102C10.1999 19.6002 11.0599 20.0702 11.9999 20.0702C12.9399 20.0702 13.7999 19.6002 14.3099 18.8102L21.6299 7.49023C22.1899 6.63023 22.2299 5.58023 21.7399 4.68023C21.2499 3.78023 20.3499 3.24023 19.3199 3.24023L4.66994 3.24023C3.64994 3.24023 2.73994 3.78023 2.24994 4.68023C1.75994 5.58023 1.79994 6.63023 2.35994 7.49023L2.36994 7.49023Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow_down_icon.0ccb297d98c6359892e62abde00c79ba.svg";
export { ForwardRef as ReactComponent };